define('components/DFPPageConfig',[
    "jquery",
    "logging",
    "ads",
    "analytics"
], function ($, logging, ads, analytics) {
    var _ModuleName = "DFP Page Config";

    function DFPPageConfig(scope, config) {
        "use strict";

        ;

        ads.registerPageConfig(config);

        // If dormant flag is defined, pass into Google Analytics Dimension
        //var blogStatus = $('html').data('dormant-blog') ? 'dormant' : 'active';
        //analytics.SetDimension(10, blogStatus);        
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            if (ads.isPreloaded()) { return null; }
            
            ;
            return new DFPPageConfig(args.scope, args.DFPPageConfig);
        }
    }
});
